export default [
  {
    logo: 'https://backlight.dev/assets/lib/fast.svg',
    logo_alt: 'test',
    featured_type: 'Lorem ipsum dolor',
    featured_url: 'https://backlight.dev',
    link_text: 'Read more',
    link_icon: 'arrow-circle-right',
  },
  {
    logo: 'https://backlight.dev/assets/lib/astro.svg',
    logo_alt: 'test',
    featured_type: 'Lorem ipsum dolor',
    featured_url: 'https://backlight.dev',
    link_text: 'Check it',
    link_icon: 'arrow-circle-right',
  },
  {
    logo: 'https://backlight.dev/assets/lib/nuxt.svg',
    logo_alt: 'test',
    featured_type: 'Lorem ipsum dolor',
    featured_url: 'https://backlight.dev',
    link_text: 'Read more',
    link_icon: 'arrow-circle-right',
  },
];
